import { useState } from "react";

export default function NotificationBell() {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="text-xl"
      >
        🔔
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-72 bg-white shadow-lg rounded-lg p-4">
          <p className="font-semibold mb-2">Notifications</p>
          <p className="text-sm text-gray-500">No new notifications</p>
        </div>
      )}
    </div>
  );
}